import { bindDragList } from "../../ui/drag-list.ts";

export function restoreSubtaskDomOrder(list: HTMLElement, ids: string[]): void {
  if (!document.contains(list)) return;
  const items = new Map(Array.from(list.querySelectorAll<HTMLElement>(":scope > .subtask-item")).map(item => [item.dataset.subtask!, item]));
  ids.forEach(id => { const item = items.get(id); if (item) list.append(item); });
}

export function bindSubtaskReordering(root: ParentNode, capabilities: { hapticFeedback(): void; undo(message: string, restore: () => void): void }): void {
  const list = root.querySelector<HTMLElement>("[data-role=subtask-list]");
  if (!list) return;
  bindDragList(list, ".subtask-item", { hapticFeedback: capabilities.hapticFeedback, dropped: original => {
    const originalIds = original.map(item => item.dataset.subtask!);
    capabilities.undo("Subtask order changed", () => restoreSubtaskDomOrder(list, originalIds));
  }});
}
